import { render } from "./Modulo_ModuUsua.vue?vue&type=template&id=a99ca8b2"
import script from "./Modulo_ModuUsua.vue?vue&type=script&lang=js"
export * from "./Modulo_ModuUsua.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__